// export const contentAPI = process.env.NODE_ENV === 'development' ? 'http://api.manasi.test/' : 'https://api.manasi7.com/';
export const contentAPI = 'https://api.manasi7.com/';

export const checkoutRoot = {
	'localhost:3000': 'checkout.manasi7.com',
	'manasi7.com': 'checkout.manasi7.com',
	'www.manasi7.com': 'checkout.manasi7.com',
};

export const checkoutAPI = (host) => {
	const version = '2021-10';
	if (typeof window === 'undefined' && !host) return `https://manasi7.myshopify.com/api/${version}/graphql.json`;
	// if (process.env.NODE_ENV === 'development') return `https://manasi7-demo.myshopify.com/api/${version}/graphql.json`;
	const checkoutRootHost = host || window.location.host;
	return `https://${checkoutRoot[checkoutRootHost] || 'manasi7.myshopify.com'}/api/${version}/graphql.json`;
};

const checkoutAccessToken = {
	'localhost:3000': '8205a1a7eb929e302e845570e664af7a',
	'manasi7.com': '8205a1a7eb929e302e845570e664af7a',
	'www.manasi7.com': '8205a1a7eb929e302e845570e664af7a',
};

export const storefrontAccessToken = (host) => {
	if (typeof window === 'undefined' && !host) return '8205a1a7eb929e302e845570e664af7a';
	const checkoutRootHost = host || window.location.host;
	return checkoutAccessToken[checkoutRootHost] || '8205a1a7eb929e302e845570e664af7a';
};

export const useLanguageURLRoots = false;

export const languageURLRoots = {};

export const origin = 'https://www.manasi7.com';

export const paymentMethodsMapping = {
	klarnaCheckout: 'klarna-checkout',
	klarnaOld: 'kreditor_v2',
	adyenCheckout: 'adyen-checkout',
	adyenDropIn: 'adyen-drop-in',
	stripeCheckout: 'stripe-checkout',
};

export const paymentMethodsOrder = [
	'klarna-checkout',
	'adyen-drop-in',
	'dibs',
	'paypal',
];

export const addressFieldOrder = [
	{ id: 'email', required: true },
	{ id: 'firstName', required: true },
	{ id: 'lastName', required: true },
	{ id: 'company', required: false },
	{ id: 'phone', required: true },
	{ id: 'address1', required: true },
	{ id: 'address2', required: false },
	{ id: 'zip', required: true },
	{ id: 'city', required: true },
	{ id: 'province', required: true },
	{ id: 'country', required: true },
	{ id: 'termsAndConditions', required: true },
];

export const urlRoots = [
	'manasi7',
];

export const urlRootLanguage = {};

export const defaultCountry = {
	localhost: 'SE',
	'manasi7.com': 'SE',
	'www.manasi7.com': 'SE',
};

export const restrictCountriesPerDomain = {};

export const baseCurrency = 'EUR';

export const shippingMethodsMapping = {};
